<template>
  <div class="index">
    <div class="pc">
        <app-header :categoryList= "categorydata" :oneList= "oneListData"></app-header>
        <div class="centers">
            <div class="content">
                <p class="breadcrumb clearfix">
                    <span class="fl">您的位置： </span>
                    <router-link class="fl" to="/index">科研人才网 > </router-link>
                    <router-link class="fl" to=""> 搜索结果页 ></router-link>
                    <router-link class="fl" to=""> 搜索 <span style="color:#FF6A6A">{{searchValue}}</span> 的结果</router-link>
                </p>
                <div class="content clearfix">
                    <ul class="fl detail">
                        <li v-for="(items,key) in dataList" :key="key">
                            <router-link target="_blank" :to="{path:'/jobDetail',query:{jobDetailId:items.recruitId}}">
                                <h3 v-html="items.title"></h3>
                                <div v-html="items.abstracts"></div>
                                <p>发布栏目 <span class="dif">{{items.categoryName}}</span> <span><i class="el-icon-date"></i>{{items.createTime}}</span><span><i class="el-icon-view"></i>{{items.lookNum}}次</span></p>
                            </router-link>
                        </li>
                        <li style="text-align:center">
                            <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 30, 50, 100]"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalPag">
                            </el-pagination>
                        </li>
                    </ul>
                    <div class="fr recommend">
                        <h3><img src="../../assets/imgs/thumbsUp.png" alt="推荐"> 推荐信息</h3>
                        <ul>
                            <li v-for="(items,i) in twoList.slice(0,10)" :key="i"  class="clearfix">
                                <span class="fl" :class="{import:i<3}">{{i+1}}</span>
                                <router-link class="fl" target="_blank" :to="{path:'/jobDetail',query:{jobDetailId:items.recruitId}}">
                                    {{items.title}}
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            
        </div>
        <app-ad :fiveListData = "threeList"></app-ad>
        <app-al :fiveListData = "threeList"></app-al>
        <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import {get, postWithJson, form} from '@/api/services'
import AppFooter from '../../components/common/footer.vue'
import AppHeader from '../../components/common/header2.vue'
import AppAd from '../../components/common/addif.vue'
import AppAl from '../../components/common/addil.vue'
export default {
    components: { AppFooter,AppHeader, AppAd, AppAl},
    name: 'search',
    data () {
        return {
            searchValue:"计算机",
            pageSize:10,
            currentPage:1,
            totalPag:0,
            threeList:'',
            categorydata:[],
            oneListData:{},
            dataList:"",
            twoList:[],
        }
    },
    created:function(){
        this.search();
        this.getMsg();
        this.initData();
    },
    methods:{
        search(){  // 搜索
            let _self = this;
            _self.searchValue = _self.$route.query.inputFlag;
            let reqData11 = {
                city:"",
                province:'',
                dictCode:'',
                companyId:'',
                keyWord:this.$route.query.inputFlag
            }
            let urls = 'front/recruit/queryRecruit?pageNum='+ _self.currentPage +'&pageSize='+_self.pageSize;
            postWithJson(urls,reqData11).then(
                function(response){
                    if(response.data.status){
                        _self.dataList = response.data.data;
                        _self.totalPag = response.data.total;
                        _self.highlights();
                    }else{
                        console.log(response.data.message);
                    }
                },
                function(response){
                    _self.$message({
                        message: "请重试",
                        type: 'error'
                    }); 
                }
            )
        },
        initData(){
            let _self = this;
            let reqData = {
                city:"",
                province:'',
                dictCode:'',
                companyId:'',
                desc:4,
                keyWord:''
            }
            postWithJson('front/recruit/queryRecruit?pageNum=1&pageSize=20',reqData).then(
                function(response){
                    if(response.data.status){
                            _self.twoList = response.data.data;
                    }else{
                        console.log(response.data.message); 
                    }
                },
                function(response){
                    _self.$message({
                        message: "请重试",
                        type: 'error'
                    });
                }
            )
        },
        getMsg(){
            let _self = this;
            get('front/dict/getDict',{dictType:'one_category'}).then(
				function(response) {
					if(response.data.status){
                        _self.categorydata = response.data.data;
                        // console.log(_self.categorydata)
					}else{
						console.log(response.data.message); 
					}
				},
				function(response) {
                    _self.$message({
                        message: response.data.msg,
                        type: 'error'
                    }); 
				}
            )

            var reqData = {categoryCode:100} 
            postWithJson('front/advertises/getAdvertisesList',reqData).then(
                function(response) {
                    if(response.data.status){
                        if(response.data.data){
                            let resData = response.data.data;
                            _self.oneListData = resData[1];
                            _self.threeList = resData[5];
                        }
                        
                    }else{
                        console.log(response.data.message);
                    }
                },
                function(response) {
                   _self.$message({
                        message: response.data.msg,
                        type: 'error'
                    });           
                }
                
            );
        },
        handleSizeChange(val) {
            this.currentPage = 1;
            this.pageSize = val;
            this.search();
            // console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.search();
            // console.log(`当前页: ${val}`);
        },
        highlights () {
          const searchValue = this.searchValue
          this.dataList = this.dataList.map(item => {
              console.log("123")
            for (let key in item) {
              if (key === 'abstracts' || key === 'title') {
                let replaceReg = new RegExp(searchValue, 'g')// 匹配关键字正则
                let replaceString = '<span style = "color: #FF6A6A;">' + searchValue + '</span>' // 高亮替换v-html值
                item[key] = item[key].replace(replaceReg, replaceString) // 开始替换
              }
           }
           return item
         })
       }

        
    },
    
}
</script>

<style scoped = "scoped"  lang = "less">
.pc{
    background-color: #f4f4f4;
    .centers{
        .content{
            width: 1200px;
            margin: 0 auto;
            overflow: hidden;
            margin-bottom: 20px;
           .breadcrumb{
                margin: 16px 0 20px;
                font-size:14px;
                font-family:PingFangSC-Regular;
                font-weight:400;
                color:rgba(51,51,51,1);
                a{
                  color:rgba(51,51,51,1); 
                  margin-left: 4px; 
                }
           }
           .detail{
                width: 840px;
                background-color: #fff;
                
                li{
                    box-sizing: border-box;
                    padding: 20px;
                    border-bottom: 1px dashed #E2E2E2;
                }
                li:last-child{
                    border-bottom: 1px solid transparent;
                }
                h3{
                    font-size: 16px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    color: #333333;
                }
                div{
                    font-size:12px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(102,102,102,1);
                    margin: 8px 0;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                p{
                   font-size: 12px;
                   color: #999;
                   span{
                       margin-right: 14px;
                       i{
                           margin-right: 6px;
                       }
                   }
                   .dif{
                       color: #1787FB;
                   }
                }
           }
           .recommend{
               width: 350px;
               background-color: white;
               padding: 20px 20px 30px;
               .highlights-text{
                   color: #FF6A6A;
               }
               h3{
                    height:64px;
                    line-height: 64px;
                    background:rgba(245,248,252,1);
                    border:1px solid rgba(203,223,243,1);
                    margin-bottom: 24px;
                    img{
                        margin:0 10px 0 20px;
                        width: 20px;
                    }
               }
               li{
                    color: #333333;
                    font-size:16px;
                    font-family:PingFangSC-Medium,PingFang SC;
                    font-weight:500;
                    /* margin-top: 16px; */
                    height: 34px;
                    line-height: 34px;
                    span{
                        display: inline-block;
                        width: 16px;
                        height: 16px;
                        line-height: 16px;
                        background-color: #E2E2E2;
                        color: #999999;
                        font-size: 12px;
                        text-align: center;
                        margin-right: 10px;
                        margin-top: 10px;
                    }
                    a{
                        display: inline-block;
                        width: 280px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-size:14px;
                        font-family:PingFangSC-Medium,PingFang SC;
                        font-weight:500;
                        color:rgba(51,51,51,1);
                    }
                    a:hover{
                        color: #1787FB;
                    }
                    .import{
                        background-color: #1787FB;
                        color: #fff;
                    }
               }
           }
        }
    }


    .footer{
        margin-top: 70px;
        .footer_top{
            text-align: center;
            background-color: #4E4E4E;
            color: #8F8F8F;
            height: 50px;
            line-height: 50px;
            vertical-align: middle;
            a{
                color: #8F8F8F;
                margin: 0 10px;
                font-size: 12px;
                vertical-align: middle;
            }
        }
        .footer_bottom{
            text-align: center;
            background-color: #303030;
            color: #8F8F8F;
            height: 190px;
            padding-top: 18px;
            font-weight:400;
            font-family:PingFangSC-Regular;
            font-size:12px;
            p{
                line-height:22px
            }
        }
          
    }
    
}
 @media all and (max-width: 768px) {
    .pc .centers .content{
        width: 100%;
    }
    .pc .centers .content .hot .half{
        width: 100%;
    }
    .detail{
        display: none;
    }
    .pc .centers .content .hot .half a .title{
        width: 96%;
    }
    .pc .centers .content .commonCss .half{
        margin-left: 0;
    }
}
</style>





// WEBPACK FOOTER //
// src/views/classify/search.vue